import { useEffect, useState } from "react";
import MainHeader from "../../../components/mainheader/MainHeaderNew";
import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import MainFooter from "../../../components/mainfooter/MainFooter";
import { axiosInstance, REACT_APP_URL } from "../../../config";
import { fetchAboutUs } from "../../../redux/slices/aboutUsSlice";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { toastError } from "../../../utils/reactToastify";
import "../PrivacyPolicy/style.css";

const CancelationPolicy = () => {
  const dispatch = useDispatch();
  const [headerImage, setHeaderImage] = useState({});
  const fetchRootCollection = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(
        `/api/header-image/title/CancelationPolicy`
      );
      if (data?.success) {
        setHeaderImage(data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toastError(error?.response?.data?.message);
      } else {
        toastError(error?.message);
      }
    }
  }, []);
  useEffect(() => {
    fetchRootCollection();
  }, [fetchRootCollection]);

  useEffect(() => {
    dispatch(fetchAboutUs());
  }, [dispatch]);

  return (
    <div style={{ backgroundColor: "#dadada96" }}>
      <StickySidebar />
      <MainHeader isImageAvailable={headerImage?.pngImage ? true : false} />
      <div
        className="div"
        style={{
          height: headerImage?.pngImage ? "60vh" : "11vh",
          overflow: "hidden",
          position: "relative",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${REACT_APP_URL}/images/header/${headerImage?.pngImage})`,
          backgroundSize: "cover",
        }}
      ></div>{" "}
      <div className="container py-3 policy-content">
        <h1 className="mb-4">
          Railingo Private Limited: No Cancellation & No Alteration Policy
        </h1>
        <p>
          <strong>Effective Date:</strong> April 1, 2025
        </p>

        <p>
          At Railingo Private Limited, we are committed to delivering
          high-quality, meticulously crafted architectural metal products,
          including our customized solutions and standard ready-made items. To
          ensure efficiency, precision, and timely fulfillment for every client,
          our operational processes involve an immediate commitment of resources
          upon order confirmation.
        </p>

        <h4>Policy Overview</h4>
        <p>
          Due to the specific nature of our manufacturing, allocation, and
          preparation processes for all products, whether they are
          custom-designed or selected from our standard range, we uphold a
          strict policy:
        </p>
        <h5>
          ● Once an order for any Railingo product has been formally confirmed,
          it cannot be cancelled or altered under any circumstances.
        </h5>

        <h4>Understanding Our Policy & Its Rationale</h4>
        <p>
          Upon your order confirmation, Railingo Private Limited immediately
          dedicates resources and initiates processes specific to your unique
          purchase:
        </p>
        <ul>
          <li>
            <strong>Immediate Resource Commitment</strong>: For{" "}
            <strong>customized products</strong>, this involves the prompt
            procurement of specialized materials and the commencement of
            detailed design and fabrication work. For{" "}
            <strong>standard/ready-made products</strong>, it involves the
            immediate booking, allocation, and specific preparation of the item
            for your order.
          </li>
          <li>
            <strong>Unique Allocation & Production</strong>: Each confirmed
            order, regardless of product type, triggers a chain of events that
            is uniquely tied to that client's requirement. This includes
            committing inventory, allocating production slots, initiating
            bespoke manufacturing processes, or preparing specific items for
            dispatch.
          </li>
          <li>
            <strong>Inability to Repurpose</strong>: Due to their nature
            (customization, specific allocation, or high-value preparation),
            products once confirmed cannot be easily rerouted, restocked, or
            resold to another client without incurring significant costs and
            operational disruptions.
          </li>
        </ul>

        <p>
          This immediate commitment and unique allocation mean that resources
          are irrevocably tied to your order, making cancellations or
          alterations financially unfeasible once confirmed.
        </p>

        <h4>Critical Action: Thorough Review Before Confirmation</h4>
        <p>
          We strongly advise all clients to undertake a comprehensive review of
          their order details, specifications, and terms{" "}
          <strong>before providing final confirmation.</strong> Our dedicated
          team is here to assist you throughout this crucial stage:
        </p>

        <ul>
          <li>
            <strong>Verify All Details</strong>: Carefully confirm product
            specifications, dimensions, finishes, quantities, delivery
            timelines, and any other relevant details for both customized and
            standard products.
          </li>
          <li>
            <strong>Approve Designs (for Custom Orders)</strong>: For customized
            products, ensure your complete satisfaction with all design and
            fabrication drawings before giving your final approval.
          </li>
          <li>
            <strong>Ask Questions</strong>: We encourage you to ask any and all
            questions you may have. Our sales and design experts are available
            to provide clarity and ensure you are fully confident in your
            purchase before you confirm your order.
          </li>
        </ul>
        <p>
          Your order confirmation signifies your explicit agreement to the final
          details and your acceptance of this "No Cancellation & No Alteration"
          policy.
        </p>

        <h4>Contact Us</h4>
        <p>
          For any questions regarding this policy or your order, please contact
          us at:
        </p>
        <address>
          <strong>Railingo Private Limited</strong>
          <br />
          Plot no. 149, Sector 4, IMT Manesar,
          <br />
          Gurugram, Haryana - 122051
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:sales@railingo.com">sales@railingo.com</a>
          <br />
          <strong>Phone:</strong> +91 8755999395
        </address>
      </div>
      <MainFooter />
    </div>
  );
};

export default CancelationPolicy;
